document.addEventListener('DOMContentLoaded', function() {
  if (!location.pathname.match(/(.*)\/news\/(.*)/)) return false
  let query = location.search
  if (query.length == 0) return false // exist query string

  let trimdQuestQuery    = query.slice(1)
  let OnlyNumQuery       = query.slice(6) // trim '?post-'
  let target             = document.querySelector('#' + trimdQuestQuery)
  let targetBtn          = target.querySelector('button.new-btn-background')
  let targetCheckBox      = target.querySelector('#p-accordion--' + OnlyNumQuery)

  // Add class & active cheked target checkbox
  $(targetBtn).trigger('click')

  // Scroll to target, calc height of header not Admin but Users-view
  let targetAbsolute     = target.getBoundingClientRect().top
  let headerHeight       = document.querySelector('#wrapper-navbar').clientHeight
  let marginSize         = parseInt(window.getComputedStyle(target).getPropertyValue('margin-bottom'), 10)
  let amount             = (targetAbsolute - headerHeight) - marginSize
  setTimeout(() => {
    window.scrollTo(0, amount)
  }, 100)
})


// WEBPACK FOOTER //
// ./news.js